import { defaultCreationVisibility } from './botCreationVisibility.js'
export { creationCapabilities } from './botCreationVisibility.js'

export const pageVisibilityPages = Object.freeze([
    { key: 'home', label: 'Home', icon: 'pi pi-home', path: '/home' },
    { key: 'my-bots', label: 'My bots', icon: 'pi pi-android', path: '/my-bots' },
    { key: 'trade-journal', label: 'Trade Journal', icon: 'pi pi-calendar', path: '/trade-journal' },
    { key: 'statistics', label: 'Statistics', icon: 'pi pi-chart-bar', path: '/statistics' },
    { key: 'api-keys', label: 'Api keys', icon: 'pi pi-key', path: '/apikeys' },
    { key: 'settings', label: 'Settings', icon: 'pi pi-cog', path: '/settings' }
])

export const pageIcons = Object.freeze({
    ...Object.fromEntries(pageVisibilityPages.map((page) => [page.key, page.icon])),
    logs: 'pi pi-list',
    customers: 'pi pi-users',
    'strategy-bot-type': 'pi pi-shield'
})

export const createDefaultPageVisibility = () => ({
    'create-bot': defaultCreationVisibility(),
    home: { visible_to_all: true, visible_to_admin_only: false },
    'my-bots': { visible_to_all: true, visible_to_admin_only: false },
    'trade-journal': { visible_to_all: true, visible_to_admin_only: false },
    statistics: { visible_to_all: true, visible_to_admin_only: false },
    'api-keys': { visible_to_all: true, visible_to_admin_only: false },
    logs: { visible_to_all: true, visible_to_admin_only: false },
    settings: { visible_to_all: true, visible_to_admin_only: false },
    customers: { visible_to_all: false, visible_to_admin_only: true },
    'strategy-bot-type': { visible_to_all: true, visible_to_admin_only: false }
})
